import { useSelector } from 'react-redux';
import { useConfig } from '@common/Hooks/useConfig';

const PAGE_KEY = 'page';

const getPrevHref = (pathname, currentPage) => {
    if (currentPage <= 1) {
        return '#';
    }

    if (currentPage === 2) {
        return pathname;
    }

    return `${pathname}?${PAGE_KEY}=${currentPage - 1}`;
};

const getNextHref = (pathname, currentPage, pageCount) => {
    if (currentPage === pageCount) {
        return '#';
    }

    return `${pathname}?${PAGE_KEY}=${currentPage + 1}`;
};

/**
 * Returns array of links for pagination component (for SEO purpose)
 *
 * @param {*} currentPage
 * @param {*} pageCount
 * @returns
 */
export const usePaginationSeoLinks = (currentPage, pageCount) => {
    const seoData = useSelector(state => state.listing.seoData);
    const { pathname } = useConfig();

    const { url_path: urlPath } = seoData || {};
    const seoPathname = urlPath || pathname;

    const prev = getPrevHref(seoPathname, currentPage);
    const next = getNextHref(seoPathname, currentPage, pageCount);

    return [next, prev, seoPathname];
};
